import Smooth from './src/index'
import css from 'dom-css'
import Bubbles from './../components/Bubbles'
import Synopsis from './../components/Synopsis'

class Split extends Smooth {

    constructor(opt) {

        super(opt)

        this.createExtraBound()

        this.sections = null

        this.synopsisLaunched = false

        this.dom.sections = Array
            .prototype
            .slice
            .call(opt.sections, 0)

        this.resizing = false
        this.activeSection = 0
        this.cache = null
        this.dom.divs = Array
            .prototype
            .slice
            .call(opt.divs, 0)

        this.initBubbles()
        this.initSynopsis()

        this.trailerBack = document.querySelector('.section-trailers__trailer__back')
        this.trailer = document.querySelector('.section-trailers__trailer__inner')
        this.inputNewsletter = document.querySelector('.footer__newsletter__form__input')
        this.arrow = document.querySelector(".section-hero__arrow")
        this.slideshowMasks = Array
            .prototype
            .slice
            .call(document.querySelectorAll('.rectangle'), 0)
        this.slideshowImgs = Array
            .prototype
            .slice
            .call(document.querySelectorAll('.img'), 0)

        this
            .arrow
            .addEventListener('click', () => {
                this.scrollTo(1)
            })

    }

    scrollTo(index) {
        console.log('scrollTo', index)
        const div = document.querySelector('#section-' + index)
        const top = div
            .style
            .top
            .replace('px', '')
        super.scrollTo(top)
    }

    initBubbles() {
        this.bubbles = new Bubbles()
        this
            .bubbles
            .init()

        const els = Array
            .prototype
            .slice
            .call(document.querySelectorAll('[data-bubble]'), 0)

        els.map((el, index) => {
            el.addEventListener('click', () => {
                this.scrollTo(index)
            })
        })
    }

    initSynopsis() {
        this.synopsis = new Synopsis()
        this
            .synopsis
            .init()
    }

    createExtraBound() {

        ['getCache', 'inViewport', 'inViewportDiv'].forEach((fn) => this[fn] = this[fn].bind(this))
    }

    resize() {
        this.resizing = true

        this
            .dom
            .sections
            .forEach((el, index) => css(el, {
                'display': 'block',
                'position': 'relative',
                'top': 0,
                'transform': 'none'
            }))

        this.vars.bounding = this
            .dom
            .sections[this.dom.sections.length - 1]
            .getBoundingClientRect()
            .bottom - (this.vars.native
            ? 0
            : this.vars.height)

        css(this.dom.section, 'height', this.bounding)

        this.getCache()

        this
            .dom
            .sections
            .forEach((el, index) => css(el, {
                'position': 'fixed',
                'width': '100%',
                'top': this.sections[index].top
            }))

        this.reset()

        super.resize()

        this.resizing = false
    }

    getCache() {

        this.sections = []

        this
            .dom
            .sections
            .forEach((el, index) => {

                const bounding = el.getBoundingClientRect();
                const bounds = {
                    el: el,
                    state: true,
                    visible: false,
                    index: index,
                    top: bounding.top,
                    bottom: bounding.bottom,
                    speed: '-1'
                }

                this
                    .sections
                    .push(bounds)
            })

        this.cache = []

        this
            .dom
            .divs
            .forEach((el, index) => {

                el.style.display = 'block'
                el.style.transform = 'none'

                const bounding = el.getBoundingClientRect()
                const bounds = {
                    el: el,
                    state: true,
                    top: bounding.top,
                    left: bounding.left,
                    center: bounding.height / 2,
                    bottom: bounding.bottom,
                    speed: el.getAttribute('data-speed') || '-1'
                }

                this.vars.bounding = bounding.bottom > this.vars.bounding
                    ? bounding.bottom - window.innerHeight
                    : this.vars.bounding;
                this
                    .cache
                    .push(bounds)
            })
    }

    run() {

        this
            .dom
            .sections
            .forEach(this.inViewport)

        this
            .dom
            .divs
            .forEach(this.inViewportDiv)

        super.run()
    }

    reset() {

        if (!this.cache) 
            return

        this
            .dom
            .divs
            .forEach((el, index) => {

                const cache = this.cache[index]

                !cache.state && (document.body.appendChild(cache.el), cache.state = true);
                el.style.display = 'block'
            })
    }

    parallaxTrailer(top, bottom) {
        const opacity = 1 - (this.vars.height - top) / 800
        const scale = 1.3 - (this.vars.height - top) / 2600
        if (opacity < 1 && opacity > 0) {
            this.trailerBack.style.opacity = opacity
        }
        if (scale > 1 && scale < 2) {
            this.trailer.style.transform = 'scale3d(' + scale + ',' + scale + ',1)'
        }
    }

    parallaxSlideshow(top, bottom) {
        const x = -500 + (this.vars.height - top) / 1.3
        const x2 = 500 - (this.vars.height - top) / 1.6
        const y1 = (-300 + (this.vars.height - top) / 2) * .2
        const y2 = (-300 + (this.vars.height - top) / 2.5) * .2

        const y3 = (600 - bottom) * .2

        if (x <= 0 && x > -500) {
            this
                .slideshowMasks[0]
                .setAttribute('x', x + 'px')

        }
        if (x2 >= 0 && x2 < 500) {
            this
                .slideshowMasks[1]
                .setAttribute('x', x2 + 'px')
        }
        if (y1 <= 0 && y1 > -300) {
            this
                .slideshowImgs[0]
                .setAttribute('y', y1 + 'px')
        }
        if (y2 <= 0 && y2 > -300) {
            this
                .slideshowImgs[1]
                .setAttribute('y', y2 + 'px')
        }

        if (bottom < 600) {
            this
                .slideshowImgs[0]
                .setAttribute('y', y3 + 'px')
            this
                .slideshowImgs[1]
                .setAttribute('y', y3 + 'px')
        }

    }

    inViewport(el, index) {

        if (!this.sections) 
            return

        const cache = this.sections[index]
        const current = this.vars.current
        const transform = current * cache.speed
        const top = Math.round(cache.top + transform)
        const bottom = Math.round(cache.bottom + transform)
        const inview = bottom > 0 && top < this.vars.height

        if (inview) {

            if (cache.index === 2) 
                this.parallaxTrailer(top, bottom)

            if (cache.index === 4) 
                this.parallaxSlideshow(top, bottom)

                // Synopsis
            top < this.vars.height - 100 && bottom > 200 && this.synopsisLaunched === false && cache.index === 1 && (this.synopsis.initAnim(), this.synopsisLaunched = true);

            // Bubbles
            top < 200 && bottom > 200 && this.activeSection !== index && (this.bubbles.goTo(cache.index), this.activeSection = cache.index, cache.visible = true);

            el.style.display = 'block'
            el.style[this.prefix] = this.getTransform(transform)

        } else {
            cache.visible && (cache.visible = false);
            el.style.display = 'none'
            el.style[this.prefix] = 'none'

            // cache.state && cache.el.parentNode &&
            // (cache.el.parentNode.removeChild(cache.el), cache.state = false);
        }
    }

    inViewportDiv(el, index) {
        if (!this.cache || this.resizing) 
            return;
        
        const cache = this.cache[index]
        const current = this.vars.current
        //const transform = current * cache.speed
        const transform = ((cache.top) - current) * cache.speed
        const top = Math.round((cache.top + transform) - current)
        const bottom = Math.round((cache.bottom + transform) - current)
        const inview = bottom > 0 && top < this.vars.height

        if (inview) {
            !cache.state && (cache.state = true);

            // el.style.display = 'block'
            el.style[this.prefix] = this.getTransform(transform)

        } else {

            // el.style.display = 'none' el.style[this.prefix] = 'none'
            cache.state && cache.el.parentNode && (cache.state = false);
        }
    }
}

export default Split


// WEBPACK FOOTER //
// ./src/js/scroll/custom.js